import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const SubCategoryMasterProvider = (props) => {
  const api = new API();
  const [fetchSubCategoryMasterList, setFetchSubCategoryMasterContextList] = useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    page: 1,
    limit: 20,
    parent_id: ''
  })
  const [editForm] = Form.useForm();
  const [editFormData, setEditFormData] = useState({});
  const [editSubCatPopup, setEditSubCatPopup] = useState(false);
  const [loaderSubCat, setLoaderSubCat] = useState(false);
  const [loader, setLoader] = useState(false);
  const fetchSubCategoryMasterContext = async (cid) => {
    setLoader(true);
    localStorage.getItem('rxdx_admin_login') === "true" && await api.getAll("categorymaster/sub", { ...tableFilter, parent_id: cid }, (err, res) => {
      setLoader(false);
      if (res?.data?.status === 200) {
        setFetchSubCategoryMasterContextList(res?.data?.data);
      } else {
        setFetchSubCategoryMasterContextList([]);
      }
    })
  };

  const addSubCategory = async (data, cid, onClose, reset) => {
    const values = {
      name: data.name,
      parent_id: cid,
    };
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("categorymaster/", values, (err, res) => {
        if (res?.data?.status === 200) {
          fetchSubCategoryMasterContext(cid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reset();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }));
  };
  const updateOrdersHides = async (id, data) => {
    // console.log(tableSetting);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update(
        "categorymaster/updateordershides",
        id,
        {
          menu_order: data.menu_order,
          hide_website: data.hide_website,
        },
        (err, res) => {
          if (res?.data?.status === 200) {
            Widget.showMessage("success", res?.data?.message);
            return;
          }
        }
      ));
  };
  const editSubCategory = async (data, id, onClose, reset, cid) => {
    const values = {
      name: data.name,
      parent_id: cid,
    };
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setLoaderSubCat(true);
    (await api.update("categorymaster/editcategory", id, values, (err, res) => {
      if (res?.data?.status === 200) {
        fetchSubCategoryMasterContext(cid);
        Widget.showMessage("success", res?.data?.message);
        onClose();
        reset();
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setLoaderSubCat(false);
    }));
  };

  return (
    <Context.Provider value={{
      ...props,
      fetchSubCategoryMasterList,
      fetchSubCategoryMasterContext,
      addSubCategory,
      tableFilter,
      setTableFilter,
      loader,
      editForm,
      editFormData, setEditFormData,
      editSubCatPopup, setEditSubCatPopup,
      loaderSubCat, setLoaderSubCat,
      editSubCategory,
      updateOrdersHides
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default SubCategoryMasterProvider;
